import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Mail, Calendar, Shield } from 'lucide-react';

const EmailCalendarTab = ({ onboardingStatus, handleGmailConnect, handleGmailDisconnect }) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Mail className="h-5 w-5 text-[#E8722A]" />
        Google Integration
      </CardTitle>
      <CardDescription>Connect your Google account to enable Gmail sending and Google Calendar sync</CardDescription>
    </CardHeader>
    <CardContent className="space-y-6">
      <div className="p-4 bg-[#F5F5F5] rounded-lg border">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className={`w-3 h-3 rounded-full ${onboardingStatus?.gmail_connected ? 'bg-green-500' : 'bg-red-400'}`} />
            <div>
              <p className="font-medium text-[#333333]">{onboardingStatus?.gmail_connected ? 'Google Connected' : 'Google Not Connected'}</p>
              {onboardingStatus?.gmail_email && <p className="text-sm text-[#666666]">{onboardingStatus.gmail_email}</p>}
            </div>
          </div>
          {onboardingStatus?.gmail_connected ? (
            <Button variant="outline" onClick={handleGmailDisconnect} className="text-red-600 border-red-300 hover:bg-red-50">Disconnect</Button>
          ) : (
            <Button onClick={handleGmailConnect} className="bg-[#E8722A] hover:bg-[#D6621F]" data-testid="connect-google-btn">
              <Mail className="mr-2 h-4 w-4" />Connect Google
            </Button>
          )}
        </div>
      </div>

      {onboardingStatus?.gmail_connected && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div className="flex items-center gap-3 p-3 bg-green-50 border border-green-200 rounded-lg">
            <Mail className="h-5 w-5 text-green-600" />
            <div>
              <p className="font-medium text-green-800 text-sm">Gmail Sending</p>
              <p className="text-xs text-green-600">Active — emails sent from your Gmail</p>
            </div>
          </div>
          <div className="flex items-center gap-3 p-3 bg-green-50 border border-green-200 rounded-lg">
            <Calendar className="h-5 w-5 text-green-600" />
            <div>
              <p className="font-medium text-green-800 text-sm">Google Calendar Sync</p>
              <p className="text-xs text-green-600">Active — interviews sync to your calendar</p>
            </div>
          </div>
        </div>
      )}

      <div className="p-4 bg-[#4B2D6E]/5 rounded-lg border border-[#4B2D6E]/20">
        <div className="flex items-start gap-3">
          <Shield className="h-5 w-5 text-[#4B2D6E] mt-0.5 flex-shrink-0" />
          <div>
            <p className="font-medium text-[#4B2D6E] mb-1">Secure OAuth Connection</p>
            <p className="text-sm text-[#666666]">
              SeniorPeerConnect™ uses Google's secure OAuth protocol. We never see or store your password — Google handles all authentication. One connection enables both Gmail sending and Calendar sync.
            </p>
          </div>
        </div>
      </div>

      <div className="text-sm text-[#666666]">
        <p className="font-medium mb-2">Connecting your Google account enables:</p>
        <ul className="list-disc list-inside space-y-1">
          <li>Application confirmation emails to candidates</li>
          <li>Interview invitation and reminder emails</li>
          <li>Offer letters and hiring documents</li>
          <li>Status update notifications</li>
          <li>Two-way Google Calendar sync for interviews</li>
          <li>Automatic conflict detection when scheduling</li>
        </ul>
      </div>
    </CardContent>
  </Card>
);

export { EmailCalendarTab };
